import { CSSProperties, FC, HTMLAttributes } from 'react';

import { useMedia } from '../../../context/InterfaceContext';

interface Props {
    alignItems?: string;
    flex?: string;
    flexColumn?: number;
    fs?: number;
    fw?: number;
    h?: number | string;
    styles?: CSSProperties;
}

export const Cell: FC<Props & HTMLAttributes<HTMLDivElement>> = ({
    alignItems,
    styles,
    h,
    fw,
    flex,
    flexColumn,
    fs,
    children,
    ...props
}) => {
    const { isMobileOrTablet } = useMedia();

    return (
        <div
            style={{
                minHeight: isMobileOrTablet ? 50 : 64,
                ...styles,
                height: h ? h : isMobileOrTablet ? 50 : 64,
                display: 'flex',
                alignItems: alignItems ? alignItems : 'center',
                flex: flex ?? 1,
                flexDirection: flexColumn ? 'column' : 'row',
                fontSize: fs ?? isMobileOrTablet ? 15 : 18,
                fontWeight: fw ?? 400,
            }}
            {...props}
        >
            {children}
        </div>
    );
};
